import { useTranslation } from 'react-i18next';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { MemoryDetails } from 'src/Components/Memories/MemoryDetails';

type MemoryParams = {
  assetId: string;
  memoryId: string;
};

const ViewMemoryDrawer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { assetId, memoryId } = useParams<MemoryParams>();
  const timelinePath = `/asset/${assetId}/memories`;
  const openRecorder = !!(location.state as { openRecorder?: boolean } | null)?.openRecorder;

  if (!memoryId) {
    return <Navigate to={timelinePath} replace />;
  }

  return (
    <AnimatedRoutedDrawer
      title={t('memories.drawer.viewTitle', 'Détail du souvenir')}
      to={timelinePath}
    >
      {({ onClose }) => (
        <MemoryDetails
          memoryId={memoryId}
          openRecorderOnMount={openRecorder}
          onEdit={() => navigate('edit', { state: { disableAnimation: true }, replace: true })}
          onDeleted={onClose}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default ViewMemoryDrawer;
